module.exports = __webpack_public_path__ + "static/media/block.3be5afaa.svg";